import moment from 'moment'

export const utcOffset = '+01'

export const getUrlByDate = (eventDate, urls = []) => {
  if (!eventDate || !urls || !urls.length || urls.length === 0) {
    return null
  }
  const now = moment().utcOffset(utcOffset)
  let startDate = moment(eventDate)
  let match = 0

  // if it is before the start date, default to first URL.
  if (now.isBefore(startDate)) {
    return urls[match]
  }

  // if it is after the event has finished, default to last URL.
  if (now.isAfter(moment(eventDate).add(urls.length, 'days'))) {
    return urls[urls.length - 1]
  }

  let endDate = moment(eventDate).add(24, 'hours')
  urls.map((url, index) => {
    if (now.isBetween(startDate, endDate)) {
      match = index
    }
    // loops and adds 24 hours so the next item in the list will represent the following day
    startDate = startDate.add(24, 'hours')
    endDate = endDate.add(24, 'hours')
    return url
  })

  return urls[match]
}
